import { GatewayConfiguration, filterValidConfiguration, selectConfiguration } from '../api.selectors';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter, map, take } from 'rxjs/operators';
import { jsonToXml, xmlToJson } from '../../../shared/utilities/xml.utils';

import { AppState } from 'src/app/app.state';
import { Injectable } from '@angular/core';
import { MD5_REQUEST_TYPES } from './md5-request.interceptor';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Injectable()
export class JsonToXmlInterceptor implements HttpInterceptor {
	/**
	 * The gateway URL that we'll match against outgoing requests to see if we should convert them
	 */
	private gatewayUrl: string;

	/**
	 * @param store Our global store and state
	 */
	constructor(store: Store<AppState>) {
		store
			.select(selectConfiguration)
			.pipe(filter(filterValidConfiguration), take(1))
			.subscribe((configuration: GatewayConfiguration) => {
				this.gatewayUrl = configuration.gatewayUrl;
			});
	}

	/**
	 * Intercepts outgoing requests going to our API to convert them to XML.
	 * @param req The HTTP request object to test against
	 * @param next The HTTP handler
	 */
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isGatewayRequest = this.isGatewayUrl(req.url);

		// If it's a POST request going to our gateway, we need to convert to XML. We don't want to do this for all post requests.
		if (
			req.method === 'POST' &&
			isGatewayRequest &&
			!MD5_REQUEST_TYPES.includes(req?.body?.SERVICE?.request_type)
		) {
			// Proxy our middleware
			const request = req.clone({
				url: req.url,
				body: jsonToXml(req.body),
				responseType: 'text',
				setHeaders: {
					'Content-Type': 'application/xml',
					Accept: 'application/xml',
				},
			});

			return next.handle(request).pipe(
				map((event) => {
					if (event instanceof HttpResponse && isGatewayRequest) {
						return event.clone({ body: xmlToJson(event.body) });
					}

					return event;
				})
			);
		}
		return next.handle(req);
	}

	/**
	 * Findout if a URL matches the gateway URL.
	 * @param url The URL to test against
	 */
	isGatewayUrl(url: string): boolean {
		return url.includes(this.gatewayUrl);
	}
}
